import { useImmerReducer } from "use-immer";
import { errorMessage } from "../../utils";
import { useEffect } from "react";
import { getActivityLogDetailsApi } from "../api/commonApi";

const reducer = (draft, action) => {
  switch (action.type) {
    case "SET_LOADING":
      draft.loading = action.payload;
      break;
    case "SET_ACTIVITY_LOG_DETAILS":
      draft.activityLogDetails = action.payload;
      break;
    default:
      break;
  }
};

export const useActivityLogDetailsDialog = (activityLogId) => {
  const [state, dispatch] = useImmerReducer(reducer, {
    loading: true,
    activityLogDetails: null,
  });

  // =============================================== API SECTION ===================================================
  const getActivityLogDetails = async () => {
    try {
      dispatch({ type: "SET_LOADING", payload: true });
      const response = await getActivityLogDetailsApi(activityLogId);

      const { success, data } = response;
      if (success) {
        dispatch({ type: "SET_ACTIVITY_LOG_DETAILS", payload: data });
      } else {
        throw response;
      }
    } catch (error) {
      const message = error.response
        ? error.response.data?.message
        : "Failed to fetch  details";

      errorMessage(message);
    } finally {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  useEffect(() => {
    if (activityLogId) getActivityLogDetails();
  }, [activityLogId]);

  return { state };
};
